import styled from "styled-components";

export const LoadingBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: "100%",
  minHeight: 500,
  backgroundColor: theme.palette.bgPage,
}));
